import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
    IconButton,
    Box,
    Pagination,
    TextField,
    InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { API_LoginURL } from "../../../config";
import axios from 'axios';
import { SaveAlt, Visibility, BarChart } from "@mui/icons-material";
import * as XLSX from "xlsx";
import SideBar from "../TeacherDashboard/TeacherSidebar/TeacherSidebar";
import Navbar from "../../Header/header";

const StudentsTable = () => {
    const [students, setStudents] = useState([]);
    const [gradeFilter, setGradeFilter] = useState("All");
    const [selectedUser, setSelectedUser] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    //const [loading] = useState(false);
    const rowsPerPage = 5;

    const navigate = useNavigate();


    const filteredStudents = students.filter(student => {
        const matchesSearch = 
            student.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            student.userName?.toLowerCase().includes(searchTerm.toLowerCase());
        
        const matchesGrade = 
            gradeFilter === "All" || student.className === gradeFilter;
        
        return matchesSearch && matchesGrade;
    });

    const totalPages = Math.ceil(filteredStudents.length / rowsPerPage);
    const currentRows = filteredStudents.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePerformanceClick = (student) => {
        navigate("/UserPerformance", { state: { student } });
    };

    const handleViewClick = (student) => {
        setSelectedUser(student);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedUser(null);
    };
   useEffect(() => {
        const fetchStudents = async () => {
            try {
                const response = await axios.get(
                    `${API_LoginURL}User/UserList`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                );
                if (Array.isArray(response.data)) {
                    setStudents(response.data);
                } else {
                    console.error(
                        "Unexpected API response format",
                        response.data
                    );
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching students:", error);
                setLoading(false);
            }
        };

        fetchStudents();
    }, []);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleGradeChange = (event) => {
        setGradeFilter(event.target.value);
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when search changes
    };

    const handleExport = () => {
        const exportData = filteredStudents.map((student, index) => ({
            "S.No": index + 1,
            "Student Name": `${student.firstName} ${student.lastName || ""}`,
            Class: student.className,
            Username: student.userName,
            Email: student.userEmailId || "N/A",
            "School Name": student.schoolName,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
        XLSX.writeFile(workbook, "Students_List.xlsx");
    };

    // Get unique class names for filter dropdown
    const uniqueClassNames = [...new Set(students.map(student => student.className))].filter(Boolean);

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box sx={{
                        height: "calc(100vh - 60px)",
                        padding: "20px",
                        backgroundColor: "#F8F9FD",
                        overflowY: "scroll",
                    }}>
                        <div className="card">
                            <div className="card-body">
                                <div style={{ padding: "20px" }}>
                                    {/* Filter and Export */}
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "20px",
                                        gap: "10px",
                                        flexWrap: "wrap"
                                    }}>
                                        <FormControl sx={{ minWidth: 200 }}>
                                            <InputLabel>Select Class</InputLabel>
                                            <Select
                                                value={gradeFilter}
                                                onChange={handleGradeChange}
                                                label="Select Class"
                                            >
                                                <MenuItem value="All">All Classes</MenuItem>
                                                {uniqueClassNames.map((className, index) => (
                                                    <MenuItem key={index} value={className}>
                                                        {className}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            placeholder="Search by name or username..."
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            sx={{ flexGrow: 1, maxWidth: 400 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<SaveAlt />}
                                            onClick={handleExport}
                                            disabled={filteredStudents.length === 0}
                                        >
                                            Export
                                        </Button>
                                    </div>
 {/* Students Table */}
                                    {/* <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>
                                                        Student Name
                                                    </TableCell>
                                                    <TableCell>Class</TableCell>
                                                    <TableCell>
                                                        User Name
                                                    </TableCell>
                                                    <TableCell>
                                                        Performance
                                                    </TableCell>
                                                    <TableCell>View</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredStudents.map(
                                                    (student, index) => (
                                                        <TableRow
                                                            key={
                                                                student.userId ||
                                                                index
                                                            }
                                                        >
                                                            <TableCell>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    student.firstName
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    student.className
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    student.userName
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                <IconButton
                                                                    color="secondary"
                                                                    onClick={() =>
                                                                        handlePerformanceClick(
                                                                            student
                                                                        )
                                                                    }
                                                                >
                                                                    <BarChart />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell>
                                                                <IconButton
                                                                    color="primary"
                                                                    onClick={() =>
                                                                        handleViewClick(
                                                                            student
                                                                        )
                                                                    }
                                                                >
                                                                    <Visibility />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer> */}
                                    {loading ? (
                                        <Box display="flex" justifyContent="center" alignItems="center" p={5}>
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        <>
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>S.No</TableCell>
                                                            <TableCell>Student Name</TableCell>
                                                            <TableCell>Class</TableCell>
                                                            <TableCell>User Name</TableCell>
                                                            <TableCell>Performance</TableCell>
                                                            <TableCell>View</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {currentRows.length > 0 ? (
                                                            currentRows.map((student, index) => (
                                                                <TableRow key={`${student.userId}-${index}`}>
                                                                    <TableCell>
                                                                        {(currentPage - 1) * rowsPerPage + index + 1}
                                                                    </TableCell>
                                                                    <TableCell>{student.firstName}</TableCell>
                                                                    <TableCell>{student.className}</TableCell>
                                                                    <TableCell>{student.userName}</TableCell>
                                                                    <TableCell>
                                                                        <IconButton
                                                                            color="secondary"
                                                                            onClick={() => handlePerformanceClick(student)}
                                                                        >
                                                                            <BarChart />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <IconButton
                                                                            color="primary"
                                                                            onClick={() => handleViewClick(student)}
                                                                        >
                                                                            <Visibility />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={6} align="center">
                                                                    No students found matching your criteria
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {filteredStudents.length > rowsPerPage && (
                                                <Box display="flex" justifyContent="center" mt={3}>
                                                    <Pagination
                                                        count={totalPages}
                                                        page={currentPage}
                                                        onChange={handlePageChange}
                                                        color="primary"
                                                        shape="rounded"
                                                    />
                                                </Box>
                                            )}
                                        </>
                                    )}

                                    {/* View Dialog */}
                                    <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                                        <DialogTitle>User Details</DialogTitle>
                                        <DialogContent dividers>
                                            {selectedUser ? (
                                                <>
                                                    <Typography gutterBottom>
                                                        <strong>Name:</strong> {selectedUser.firstName} {selectedUser.lastName || ''}
                                                    </Typography>
                                                    <Typography gutterBottom>
                                                        <strong>Username:</strong> {selectedUser.userName}
                                                    </Typography>
                                                    <Typography gutterBottom>
                                                        <strong>Class:</strong> {selectedUser.className}
                                                    </Typography>
                                                    <Typography gutterBottom>
                                                        <strong>Email:</strong> {selectedUser.userEmailId || "N/A"}
                                                    </Typography>
                                                    <Typography gutterBottom>
                                                        <strong>School:</strong> {selectedUser.schoolName}
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Typography>Loading user details...</Typography>
                                            )}
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseDialog} color="primary">
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default StudentsTable;